jQuery(document).ready(function() {
    jQuery(".logo-slider").slick({

        // normal options...
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        arrows: true,

        // the magic
        responsive: [{

            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                arrows: true,
            }

        }, {

            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                arrows: true,
            }

        }, {

            breakpoint: 300,
            settings: "unslick" // destroys slick

        }]
    });
})

